export default {
  login: '登录',
  systemLogin: '系统登录',
  oldPassword: '旧密码',
  newPassword: '新密码',
  password: '密码',
  username: '用户名',
  rememberMe: '记住我',
  phoneNumber: '手机号码',
  verificationCode: '验证码',
  getVerificationCode: '获取验证码',
  reacquire: '重新获取({{time}})',
  phoneNumberError: '请输入有效的11位手机号码',
  resetPassword: '重置密码',
  verificationPassed: '验证通过',
  forgetPassword: '忘记密码?',
  confirmPassword: '确认密码',
  confirmPasswordMessage: '密码和确认密码不相同!',
  notPermissions: '用户暂无权限登录',
  passwordRuleMessage: '密码为6-30位必须包含字母和数字!',
};
